<template>
  <div class="orderInfo-infoWrapper textStyleFile">
    <div class="d-flex orderInfo-col">
      <v-tooltip bottom open-on-hover open-on-click>
        <template v-slot:activator="{ on, attrs }">
          <div
            style="margin-right:4px;width: 19px; height: 19px"
            v-on="on"
            v-bind="attrs"
          >
            <InfoIcon />
          </div>
        </template>
        <div>Үүсгэсэн огноо: {{ info.createdAt }}</div>
      </v-tooltip>
      <span
        class="orderInfo-title
 "
        >Нэхэмжлэлийн дугаар: </span
      >{{ info.invoiceNumber }}
    </div>
    <div class="orderInfo-col">
      <span
        class="orderInfo-title
 "
        >Тайлбар: </span
      >{{ info.planName }}
    </div>
    <div class="orderInfo-col">
      <span
        class="orderInfo-title
 "
        >Ширхэг: </span
      >{{ info.quantity }}
    </div>
    <div class="orderInfo-col">
      <span
        class="orderInfo-title
 "
        >Багцын үнэ: </span
      >{{ getFormatNumber(info.amount) }}₮
    </div>
    <div class="d-flex orderInfo-col">
      <span
        class="orderInfo-title
 "
        >Төлөв:
      </span>
      <div class="circle" :class="getStatusColor()"></div>
      {{ getStatusText()
      }}<v-tooltip v-if="info.status == 1" bottom open-on-hover open-on-click>
        <template v-slot:activator="{ on, attrs }">
          <div
            style="margin-left:4px;width: 19px; height: 19px"
            v-on="on"
            v-bind="attrs"
          >
            <InfoIcon />
          </div>
        </template>
        <div>Төлбөр төлсөн огноо: {{ info.paidAt }}</div>
      </v-tooltip>
    </div>
    <div class="orderInfo-col orderInfo-showCol">
      <a class="link" :href="info.url" target="_blank">
        <v-btn class="orderInfo-showBtn">нээх</v-btn>
      </a>
    </div>
  </div>
</template>
<script>
import { format } from "date-fns";
import { mapActions } from "vuex";
import InfoIcon from "../components/icons/InfoIcon";
import { InvoiceRequest } from "../invoice_pb";
import { InvoiceInfoClient } from "../invoice_grpc_web_pb";
export default {
  name: "OrderInfo",
  data: () => ({
    status: "",
  }),
  components: { InfoIcon },
  props: {
    info: {
      invoiceNumber: String,
      planName: String,
      amount: Number,
      quantity: Number,
      createdAt: String,
      paidAt: String,
      status: Number,
      idToken: String,
      url: String,
      client_key: String,
    },
  },
  created() {
    this.client = new InvoiceInfoClient(
      process.env.VUE_APP_GRPC_URL,
      null,
      null
    );
  },
  mounted() {
    if (this.info.status == 0) {
      this.addInvoice();
    }
  },
  computed: {
    getToken: function() {
      return this.$cookie.get("token");
    },
  },
  methods: {
    ...mapActions(["showErrorMessage", "checkError"]),
    addInvoice() {
      let params = new InvoiceRequest();
      params.setClientKey(this.info.client_key);
      params.setInvoiceNumber(this.info.invoiceNumber);
      this.client.addInvoice(
        params,
        {
          token: this.getToken,
        },
        (err, response) => {
          if (err) {
            console.log(err);
          } else {
            console.log(response.toObject());
          }
        }
      );
    },
    getFormatNumber(number) {
      return Intl.NumberFormat().format(number);
    },
    getFormatDate(date) {
      var currentDate = new Date(date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    getPageCount(characterLength) {
      return Math.ceil(characterLength / 3750);
    },
    getStatusColor() {
      switch (this.info.status) {
        case 0:
          return "orderInfo-wait";
        case 1:
          return "orderInfo-paid";
        case 2:
          return "orderInfo-halfPaid";
        // default:
        //     return 'orderInfo-exp';
      }
    },
    getStatusText() {
      switch (this.info.status) {
        case 0:
          return "Төлбөр хүлээгдэж байна";
        case 1:
          return "Амжилттай";
        case 2:
          return "Хагас төлөгдсөн";
        // default:
        //     return 'orderInfo-exp';
      }
    },
    toDateTime(secs) {
      var t = new Date(1970, 0, 1); // Epoch
      t.setSeconds(secs);
      // t.setHours(t.getHours());
      return format(t, "yyyy/MM/dd HH:mm");
    },

    redirectUrl() {
      window.location.href = this.info.url;
    },
  },
};
</script>

<style>
.orderInfo-infoWrapper {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 5px;
  width: 100%;
  height: 65px;
  align-items: center;
  transition: 0.2s ease-out;
  border-bottom: 1px solid #e8ebed;
  cursor: pointer;
}

.orderInfo-infoWrapper:hover {
  background-color: #f8f8f8;
  transition: 0.2s ease-out;
}

.textStyleFile {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  text-align: left;
}

.orderInfo-title {
  display: none;
  width: 120px;
  color: #767676;
}

.orderInfo-showCol {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .orderInfo-col {
    display: flex;
    align-items: center;
    height: 30px;
  }

  .orderInfo-showCol {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .orderInfo-infoWrapper {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(6, 1fr);
    height: auto;
    padding: 8px;
  }

  .orderInfo-title {
    display: block;
  }
}
.orderInfo-exp {
  background-color: #f11a1a;
}

.orderInfo-paid {
  background-color: #34a853;
}
.orderInfo-wait {
  background-color: #fe6d26;
}

.orderInfo-halfPaid {
  background-color: #34a853aa;
}

.circle {
  display: flex;
  align-self: center;
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  border-radius: 50px;
  margin-right: 4px;
}

.orderInfo-showBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}
</style>
